import * as Fertilization from './FertilizationRoot';

export type FertilizationProps = {
  className?: string;
};

export const FertilizationPage = ({ className }: FertilizationProps) => {
  return (
    <Fertilization.Root className={`fertilization-page ${className}`.trim()}>
      <Fertilization.Toolbar className="toolbar" />
      <Fertilization.Panel className="panel" />
    </Fertilization.Root>
  );
};
